<div class="container mt-4" style="min-height:calc(100vh - 300px);">

    <div class="row">

        <div class="col-lg-12">
            <h4 class="font-medium">📊 Audit Fee MPR</h4>
        </div>
        <div class="col-lg-4 col-md-6 mb-3">
            <label class="form-label">Total No.of Audit Conducted up to Date<sup class="text-danger">*</sup></label>
            <input type="text" class="form-control" placeholder="Please Enter">
        </div>
        <div class="col-lg-12">
            <div class="card">
                <div class=" card-header">
                    <h5 class="font-medium m-0">📄 Departmental Auditor</h5>
                </div>
                <div class="card-body">

                    <div class="row">
                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Audit fee Assessed<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Audit fee Recovered<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Total No. of Audit Conducted<sup
                                    class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Balance of Audit Fee<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                    </div>

                </div>
            </div>
        </div>


        <div class="col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h5 class="font-medium m-0">📄 Certified Auditor</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Audit Fee Assessed<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Audit Fee Recovered<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Total No.of Audit Conducted<sup
                                    class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Balance of Audit Fee<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h5 class="font-medium m-0">📄 Chartered Accountant</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Audit Fee Assessed<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Audit Fee Recovered<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Total No. of Audit Conducted<sup
                                    class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Balance of Audit Fee<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="card">
                <div class="card-header">
                    <h5 class="font-medium m-0">📄 Retiree Auditor</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Audit Fee Assessed<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Audit Fee Recovered<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Total No. of Audit Conducted<sup
                                    class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>

                        <div class="col-lg-3 col-md-6 mb-2">
                            <label class="form-label">Balance of Audit Fee<sup class="text-danger">*</sup></label>
                            <input type="text" class="form-control" placeholder="Please Enter">
                        </div>



                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-12 text-end mb-4">
            <button type="submit" class="btn btn-primary">Save</button>
        </div>

    </div>
</div>